/**
 * @fileoverview Module for `src/lib/stats.js`.
 */

/**
 * Voter stat shaping helpers.
 */

/**
 * Splits a voter list into to-prep/to-send/already-sent subsets.
 *
 * @param {Object[]} voters - Voter rows.
 * @returns {Object} Grouped voter arrays.
 */
function denormalizeVoterLists(voters) {
  return {
    toPrep: voters.filter(
      (voter) => voter.toPrep,
    ) || [],
    toSend: voters.filter(
      (voter) => voter.toSend,
    ) || [],
    alreadySent: voters.filter(
      (voter) => voter.alreadySent,
    ) || [],
  };
}

/**
 * Returns distinct voter states from a voter collection.
 *
 * @param {Object[]} voters - Voter rows.
 * @returns {string[]} Unique state abbreviations.
 */
function uniqueVoterStates(voters) {
  return [...new Set(voters.map((voter) => voter.state))] || [];
}

export {
  denormalizeVoterLists,
  uniqueVoterStates,
};
